import React, { useEffect, useState } from "react";
import api from "../../Environment";
import styles from './LandingPage.module.css';

const TopOfMonth = (props) => {

    return (
        <section className={`${styles.landingContainer} ${styles.earners}`}>
            <div className={styles.landingSectionTitle}>
                TOP EARNERS <br />
                <span className={styles.colorText} >THIS MONTH</span>
            </div>

            <div className={styles.earnersGrid}>
                {props.topEarners.map((list, i) => (
                    <img key={i}
                        src={list.profile_image && list.profile_image != null && list.profile_image != ""
                            ? api.serviceUrl() + "/" + list.profile_image
                            : "/assets/images/upload-profile-img.svg"}
                        alt={list.title}
                        className={styles.topEarners}
                    />
                ))}
            </div>
        </section>
    );
};

export default TopOfMonth;